import type { FC } from 'react'
import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import NotificationPage from '@/pages/NotificationPage'
import SearchPage from '@/pages/SearchPage'
import UserPage from '@/pages/UserPage/UserPage'

import DispatcherLayout from '../../layouts/DispatcherLayout'
import ChatPage from '../../pages/ChatPage'
import { CustomerManagementPage } from '../../pages/Dispatcher/CustomerManagementPage'
import CustomerPage from '../../pages/Dispatcher/CustomerPage'
import DashboardPage from '../../pages/Dispatcher/DashboardPage'
import NotificationManagerPage from '../../pages/Dispatcher/NotificationManagerPage'
import ReportsPage from '../../pages/Dispatcher/ReportsPage'
import ResourceSchedulingPage from '../../pages/Dispatcher/ResourceSchedulingPage'
import { Settings } from '../../pages/Dispatcher/Settings'
import TechnicianManagementPage from '../../pages/Dispatcher/TechnicianManagementPage'
import TechnicianPage from '../../pages/Dispatcher/TechnicianPage'
import { UserRoleEnum } from '../../types'

import ProtectedRoute from './ProtectedRoute'
import { EnumDispatcherRoutes, EnumGlobalRoutes } from './routerConstants'

const DispatcherRoutes: FC = () => (
    <ProtectedRoute allowedRoles={[UserRoleEnum.DISPATCHER]}>
        <Routes>
            <Route element={<DispatcherLayout />}>
                <Route index element={<DashboardPage />} />{' '}
                <Route
                    path={EnumDispatcherRoutes.DISPATCHER_SHEDULING}
                    element={<ResourceSchedulingPage />}
                />
                <Route
                    path={EnumDispatcherRoutes.DISPATCHER_TECHNICIANS}
                    element={<TechnicianManagementPage />}
                />
                <Route
                    path={EnumDispatcherRoutes.DISPATCHER_TECHNICIANS + '/:id'}
                    element={<TechnicianPage />}
                />
                <Route
                    path={EnumDispatcherRoutes.DISPATCHER_CUSTOMERS_MANAGEMENT}
                    element={<CustomerManagementPage />}
                />
                <Route
                    path={
                        EnumDispatcherRoutes.DISPATCHER_CUSTOMERS_MANAGEMENT +
                        '/:id'
                    }
                    element={<CustomerPage />}
                />
                <Route
                    path={EnumDispatcherRoutes.DISPATCHER_REPORTS}
                    element={<ReportsPage />}
                />
                <Route
                    path={EnumGlobalRoutes.NOTIFICATION}
                    element={<NotificationManagerPage />}
                />
                <Route path={EnumGlobalRoutes.CHAT} element={<ChatPage />} />
                <Route
                    path={EnumGlobalRoutes.CHAT + '/:id'}
                    element={<ChatPage />}
                />
                <Route
                    path={EnumGlobalRoutes.USER_PAGE + ':id'}
                    element={<UserPage />}
                />
                <Route
                    path={EnumGlobalRoutes.SEARCH}
                    element={<SearchPage />}
                />
                <Route
                    path={EnumGlobalRoutes.NOTIFICATIONS}
                    element={<NotificationPage />}
                />
                <Route
                    path={EnumGlobalRoutes.SETTINGS}
                    element={<Settings />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    </ProtectedRoute>
)

export default DispatcherRoutes
